var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-body"},[_c(_vm.curentComponents,{tag:"component",on:{"showOther":_vm.showOther}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }